import { Page } from 'layouts/Page';
import { FC } from 'react';
import { EuDdp } from 'components/EuDdp';

export const EuDdpPage: FC = () => {
	return (
		<Page title="EU DDP – EAS Dashboard">
			<EuDdp />
		</Page>
	);
};
